/**
 * Shared Y-axis helpers for the recharts money charts (Analysis
 * income/expense chart, projected balances). Extracted from
 * IncomeExpenseChart.js so every chart scales and labels the same way.
 */

// "Nice" rounded axis scaling so Y ticks read as round numbers ($0, $5k, $10k…)
// instead of the data-derived endpoints recharts would otherwise pick.
const niceNum = (range, round) => {
  if (!isFinite(range) || range <= 0) return 1;
  const exponent = Math.floor(Math.log10(range));
  const fraction = range / Math.pow(10, exponent);
  let nf;
  if (round) {
    if (fraction < 1.5) nf = 1; else if (fraction < 3) nf = 2; else if (fraction < 7) nf = 5; else nf = 10;
  } else {
    if (fraction <= 1) nf = 1; else if (fraction <= 2) nf = 2; else if (fraction <= 5) nf = 5; else nf = 10;
  }
  return nf * Math.pow(10, exponent);
};

export const niceScale = (min, max, maxTicks = 5) => {
  if (!isFinite(min) || !isFinite(max)) return { domain: ['auto', 'auto'], ticks: undefined };
  if (min === max) { min -= 1; max += 1; }
  const range = niceNum(max - min, false);
  const spacing = niceNum(range / Math.max(1, maxTicks - 1), true);
  const niceMin = Math.floor(min / spacing) * spacing;
  const niceMax = Math.ceil(max / spacing) * spacing;
  const ticks = [];
  for (let v = niceMin; v <= niceMax + spacing * 0.5; v += spacing) ticks.push(Math.round(v));
  return { domain: [niceMin, niceMax], ticks };
};

// Compact currency for axis ticks: $16.5k / -$9.6k / $0
export const formatAxisCurrency = (value) => {
  if (!isFinite(value)) return '';
  if (value === 0) return '$0';
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (abs >= 1000) {
    const k = abs / 1000;
    const s = k >= 100 ? String(Math.round(k)) : String(Math.round(k * 10) / 10);
    return `${sign}$${s}k`;
  }
  return `${sign}$${Math.round(abs)}`;
};
